import { Component } from '@angular/core';
import { Location } from '@angular/common';
// import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-botao-voltar',
  templateUrl: './botao-voltar.component.html',
  styleUrls: ['./botao-voltar.component.css']
})
export class BotaoVoltarComponent {
  //@Input() seguirRotaNavegacao: boolean = true;
  
  constructor(private _location: Location,
              //private route: ActivatedRoute,
              //private router: Router
              ) { }
  
  voltar() {
    //if (this.seguirRotaNavegacao) {
      this._location.back();      
    // } else {
    //   this.router.navigate(['..']);
    // }    
  }
}
